module.exports = __webpack_public_path__ + "static/media/PDF_42.b217d2f2.pdf";